import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazySources = lazy(() => import('./Sources'));

export const Sources: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazySources {...props} />
	</Suspense>
);
